import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Activity, ChevronRight } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';

const statusColors = {
  nuovo: 'bg-blue-100 text-blue-800',
  contattato: 'bg-cyan-100 text-cyan-800',
  assegnato: 'bg-sky-100 text-sky-800',
  appuntamento_fissato: 'bg-amber-100 text-amber-800',
  sopralluogo_effettuato: 'bg-orange-100 text-orange-800',
  in_preventivazione: 'bg-yellow-100 text-yellow-800',
  preventivo_presentato: 'bg-purple-100 text-purple-800',
  in_trattativa: 'bg-indigo-100 text-indigo-800',
  in_contratto: 'bg-pink-100 text-pink-800',
};

export const RecentCommercialActivity = ({ items = [] }) => {
  const shown = items.slice(0, 5);
  return (
    <Card className="bg-white rounded-xl border border-[#E4E4E4] shadow-sm h-full flex flex-col" data-testid="direzione-recent-activity">
      <CardHeader className="pb-3 flex flex-row items-center justify-between">
        <CardTitle className="text-base font-semibold flex items-center gap-2 min-w-0">
          <Activity className="w-5 h-5 text-[#FF7819] shrink-0" />
          <span className="truncate">Attività commerciale recente</span>
        </CardTitle>
        <Link to="/estimates" className="text-sm text-[#FF7819] hover:underline flex items-center gap-1 shrink-0 whitespace-nowrap" data-testid="recent-activity-all-link">
          Vedi tutte <ChevronRight className="w-4 h-4" />
        </Link>
      </CardHeader>
      <CardContent className="pt-0 flex-1">
        {shown.length === 0 ? (
          <p className="text-sm text-gray-500 py-6 text-center">Nessuna attività commerciale recente</p>
        ) : (
          <div className="space-y-2">
            {shown.map((item) => (
              <Link
                key={item.lead_id}
                to={item.link}
                data-testid={`recent-activity-${item.lead_id}`}
                className="flex items-center justify-between p-2.5 rounded-lg hover:bg-gray-50 transition-colors group no-underline text-inherit"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 font-medium text-sm shrink-0">
                    {item.client_name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">{item.client_name}</p>
                    <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                      <span className={`text-xs px-2 py-0.5 rounded-full ${statusColors[item.status] || 'bg-gray-100 text-gray-700'}`}>
                        {item.status_label}
                      </span>
                      <span className="text-xs text-gray-400">{item.last_activity_label}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0 text-right">
                  <div>
                    {item.value ? <p className="text-sm font-medium text-gray-700">{formatCurrency(item.value)}</p> : null}
                    {item.technician_name ? <p className="text-xs text-gray-400">{item.technician_name}</p> : null}
                  </div>
                  <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-[#FF7819] transition-colors" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
